const DefaultActions = {
  LOGIN: '[User] Login'
}

const login = (payload, redirect) => ({
  type: DefaultActions.LOGIN,
  payload,
  redirect
})

export const Actions = {
  login
}

export const ActionTypes = {
  login: DefaultActions.LOGIN
}



// WEBPACK FOOTER //
// ./src/components/layouts/login/store.js